export default function truncateText(str, length) {
    if (typeof str === "string" && str.length > length) {
        return str.substring(0, length) + "...";
    } else {
        return str;
    }
}